<script lang="ts" setup>
import StandardsAllFilters from '@/components/Search/SearchBar/Standards/StandardsAllFilters.ce.vue';
import CollectionAllFilters from '@/components/Search/SearchBar/Collections/CollectionAllFilters.ce.vue';
import { useSearchStore } from '@/components/Search/store/index.ts'
import { STANDARDS_SEARCH_TAB, COLLECTIONS_SEARCH_TAB } from '@/components/Search/constants.ts';


const searchStore = useSearchStore()

</script>

<template>
    <StandardsAllFilters  v-show="searchStore.activeTab == STANDARDS_SEARCH_TAB"></StandardsAllFilters>
    <CollectionAllFilters  v-show="searchStore.activeTab == COLLECTIONS_SEARCH_TAB"></CollectionAllFilters>
</template>
<style lang="scss">
    @use './style.scss';
</style>